import styled from 'styled-components';
import { applyFlexLayout } from '@belong/themes';
import { ILayoutControl } from '@belong/types';

const ButtonGroup = styled.div<ILayoutControl>`
  ${applyFlexLayout};
`;

ButtonGroup.displayName = 'ButtonGroup';
export default ButtonGroup;
